import { Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { SpeechModelComponent } from 'src/app/views/my-space/global-settings/speech-model.component';
import { Command } from './audio-menus.dto';

@Component({
  selector: 'app-audio-recording-options',
  imports: [TranslateModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, SpeechModelComponent],
  template: `
    <div class="custom-context-menu-wrapper d-flex flex-column gap-2 mb-1 p-2">
      @switch (uiState()) {
        @case ('initial') {
          <button mat-flat-button (click)="selectionAction('restart')">
            {{ 'MediaRecorder.RestartRecording' | translate }}
          </button>
          <button mat-flat-button (click)="selectionAction('continue')">
            {{ 'MediaRecorder.ContinueRecording' | translate }}
          </button>
        }
        @case ('loading') {
          <!-- Loading spinner to prevent unintentional fast clicks -->
          <div class="d-flex justify-content-center align-items-center h-100">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
        }
        @case ('confirming') {
          @if (bypassModelSelection()) {
            <button mat-flat-button (click)="sendCommand()">
              {{ 'MediaRecorder.ProceedWithRestart' | translate }}
            </button>
          } @else {
            <app-speech-model class="pt-1" />
            <button mat-flat-button (click)="sendCommand()">
              {{ 'MediaRecorder.ProceedWithRestart' | translate }}
            </button>
          }
        }
      }
    </div>
  `,
})
export class AudioRecordingOptionsComponent {
  @Output() commandSelected = new EventEmitter<Command>();

  private featureFlagService = inject(FeatureFlagService);

  uiState = signal<'initial' | 'loading' | 'confirming'>('initial');
  selectedAction = signal<'restart' | 'continue' | null>(null);
  bypassModelSelection = signal<boolean>(this.featureFlagService.isFeatureEnabled('bypassTranscriptionModelSelection'));

  selectionAction(action: 'restart' | 'continue'): void {
    if (this.bypassModelSelection() && action === 'continue') {
      this.selectedAction.set(action);
      this.sendCommand();
    } else {
      this.selectedAction.set(action);
      this.uiState.set('loading');
      setTimeout(() => this.uiState.set('confirming'), 0);
    }
  }

  sendCommand(): void {
    const output: Command = {
      type: this.selectedAction() === 'restart' ? 'restart-recording' : 'continue-recording',
      data: {},
    };
    this.commandSelected.emit(output);
  }
}
